export const SegmentTargetType = {
    Custom: {
        label: 'Custom Segments',
        value: [1],
        key: 'Custom'
    },
    SegmentSet: {
        label: 'Segment Set',
        value: [3],
        key: 'SegmentSet'
    },
    TVA: {
        label: 'TVA Segments',
        value: [21, 24],
        key: 'TVA'
    },
    TVADeterministic: {
        label: 'TVA Deterministic Segments',
        value: [22, 25],
        key: 'TVADeterministic'
    }
}